export const fetchRemoveBettorAccount = async (
    bettorAccountId: string,
    publicToken: string,
    churnReason: string | null
) => {
    if (churnReason)
        var url = `${
            process.env.REACT_APP_API_BASE || ''
        }/v1/bettorAccounts/${bettorAccountId}/access?reason=ui&churnReason=${churnReason}`;
    else
        var url = `${
            process.env.REACT_APP_API_BASE || ''
        }/v1/bettorAccounts/${bettorAccountId}/access?reason=ui`;
    return await fetch(url, {
        method: 'PUT',
        headers: {
            Authorization: `Token ${publicToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ access: false }),
    });
};

export const fetchPauseBettorAccount = async (
    bettorAccountId: string,
    publicToken: string,
    paused: boolean
) => {
    return await fetch(
        `${
            process.env.REACT_APP_API_BASE || ''
        }/v1/bettorAccounts/${bettorAccountId}/paused`,
        {
            method: 'PUT',
            headers: {
                Authorization: `Token ${publicToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ paused }),
        }
    );
};

export const fetchContext = async (cid: string) => {
    return await fetch(
        `${process.env.REACT_APP_API_BASE || ''}/v1/contexts/${cid}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Token ${process.env.REACT_APP_SUPERUSER_API_KEY}`,
            },
        }
    );
};

export const fetchRefreshBettorAccount = async (
    bettorAccountId: string,
    publicToken: string,
    reverify: boolean,
    auth: string | null,
    service: string | null
) => {
	const extensionVersion = sessionStorage.getItem("sharpSportsExtensionVersion");
	let url = `${process.env.REACT_APP_API_BASE || ''}/v1/bettorAccounts/${bettorAccountId}/refresh?auth=${auth}`;
	if (reverify) url = url.concat('&reverify=true');
	if (service) url = url.concat(`&service=${service}`);
	if (extensionVersion) url = url.concat(`&extensionVersion=${extensionVersion}`);

	console.log("URL: ", url)

    return await fetch(url, {
        method: 'POST',
        headers: {
            Authorization: `Token ${publicToken}`,
            'Content-Type': 'application/json',
        },
    });
};

export const fetchRefreshAllBettorAccounts = async (
	internalId: string,
	publicToken: string,
	auth: string | null,
	service: string | null
) => {
	const extensionVersion = sessionStorage.getItem("sharpSportsExtensionVersion")
  	let url = `${process.env.REACT_APP_API_BASE || ''}
	/v1/bettors/${internalId}/refresh?auth=${auth}`;
  	if (service) url = url.concat(`&service=${service}`);
  	if (extensionVersion) url = url.concat(`&extensionVersion=${extensionVersion}`);
  	return await fetch(url, {
		method: 'POST',
		headers: {
		Authorization: `Token ${publicToken}`,
		'Content-Type': 'application/json',
		},
	});
};
